export default function stopHandler (selector) {
  document.querySelectorAll(selector).forEach((node) => {
    node.addEventListener('click', (e) => {
      e.stopPropagation()
    })
  })
}
